import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { FileUploader } from "react-drag-drop-files";
import Progress from 'react-progressbar';
import { useSelector } from 'react-redux';
import Select from "react-select";
import { useNavigate, useParams } from 'react-router-dom';
import UploadSection from "./UploadSection"
import { ASSET_CREATE_VERSION, GET_VERSION_HISTORY } from '../../../apiClient/apiEndpoints';
import apiClient from '../../../apiClient';
import { toastError } from '../../utils/toast';


const emptyFile = {
    gltf: {url: null},
    fbx: {url: null},
    glb: {url: null},
    zip: {url: null},
}


const UploadAsset = ({saveAssets, handelSaveDetails, setAssetError}) => {

    const navigate = useNavigate();
    const configData = useSelector((state) => state.configSlice);
    const userData = useSelector((state) => state.userSlice);
    const navigator = useNavigate();
    const params = useParams();
    const uuid = params.id;
    const [uploadedFile, setUploadedFile] = useState(emptyFile);

    const [uploadFile, setUploadFile] = useState({
        gltf: null,
        fbx: null,
        glb: null,
        zip: null,
    });

    const[versionsList, setVersionsList] = useState({
        gltf: [],
        fbx: [],
        glb: [],
        zip: [],
    });

    const [error, setError] = useState({
        gltf: null,
        fbx: null,
        glb: null,
        zip: null,
    });

    const [loading, setLoading] = useState({
        gltf: false,
        fbx: false,
        glb: false,
        zip: false,
    });

    const [uploadProgress, setUploadProgress] = useState({
        gltf: 0,
        fbx: 0,
        glb: 0,
        zip: 0,
    });

    const [renderer, setRendererUsedTag] = useState({
        gltf: null,
        fbx: null,
        glb: null,
        zip: null,
    });
    const [version, setAssetVersion] = useState({
        gltf: "",
        fbx: "",
        glb: "",
        zip: "",
    });

    const [rendererTagList, setRendererTagList] = useState([
        {label: "Select ", value: null },
        {label: "V-Ray", value: "vray" },
        {label: "Unity 3D", value: "unity3d" }
    ]);

    const validateFields = (fields, type) => {
        setError(pre => ({ ...pre, [type]: null }));
        let errorStatus = false;
        let errorMessage = null;
        fields.forEach(field => {
            switch (field) {
                case "version":
                    if (version[type].trim().length === 0) {
                        errorMessage = `Kindly enter ${type} ${field}.`
                        setError(pre => ({ ...pre, [type]: errorMessage }));
                        errorStatus = true;
                    }
                    break;
                case "renderer":
                    if (!renderer[type]) {
                        errorMessage = `Kindly enter ${type} ${field}.`
                        setError(pre => ({ ...pre, [type]: errorMessage }));
                        errorStatus = true;
                    }
                    break;
                case "uploadFile":
                    if (!uploadFile[type]) {
                        errorMessage = `Kindly upload ${type} file.`
                        setError(pre => ({ ...pre, [type]: errorMessage }));
                        errorStatus = true;
                    }
                    break;
                default:
                    console.warn(`Unknown field type: ${field}`);
            }
        });
    
        if (errorStatus) {
            toastError(errorMessage);
            setAssetError(errorMessage);
            setTimeout(() => { setAssetError(null); }, 5000);
        }
        return errorStatus;
    };
    

 // Validation for glb and zip (all or nothing)
 const checkAllOrNothing = (type) => {
    const allEmpty = version[type].trim().length === 0 && !renderer[type] && !uploadFile[type];
    const allFilled = version[type].trim().length > 0 && renderer[type] && uploadFile[type];
    return allEmpty || allFilled;
};

    const saveAssetsAsync =async() =>{
        if(saveAssets){
         let errorStatus = false
         setAssetError(null);
        //  if(version["gltf"].trim().length === 0){ setError(pre => ({...pre, ["gltf"]: "Kindly enter version."  })); errorStatus = true; }
        //  if(!renderer["gltf"]){ setError(pre => ({...pre, ["gltf"]: "Kindly select renderer."  })); errorStatus = true; }
        //  if(!uploadFile["gltf"]){ setError(pre => ({...pre, ["gltf"]: "Kindly upload file."  })); errorStatus = true; } 
         
        //  if(version["fbx"].trim().length === 0){ setError(pre => ({...pre, ["fbx"]: "Kindly enter version."  })); errorStatus = true; }
        //  if(!renderer["fbx"]){ setError(pre => ({...pre, ["fbx"]: "Kindly select renderer."  })); errorStatus = true; }
        //  if(!uploadFile["fbx"]){ setError(pre => ({...pre, ["fbx"]: "Kindly upload file."  })); errorStatus = true; } 
         
        // if (validateFields(["version", "renderer", "uploadFile"], "gltf")) {
        //    return;
        //     }
        
        if (validateFields(["version", "renderer", "uploadFile"], "fbx")) {
            return;
           }

        //  if(errorStatus){ 
        //      toastError("Kindly upload GTLF and FBX files.");
        //      setAssetError("Kindly upload GTLF and FBX files."); 
        //      setTimeout(()=>{ setAssetError(null); }, 5000);
        //      return; 
        //  };
    
         if (!checkAllOrNothing("gltf")) {
             toastError("For GLTF, please fill out all fields or leave all fields blank.");
             setAssetError("For GLTF, please fill out all fields or leave all fields blank.");
             setTimeout(() => { setAssetError(null); }, 5000);
             return;
         }
         if (!checkAllOrNothing("glb")) {
             toastError("For GLB, please fill out all fields or leave all fields blank.");
             setAssetError("For GLB, please fill out all fields or leave all fields blank.");
             setTimeout(() => { setAssetError(null); }, 5000);
             return;
         }
    
         if (!checkAllOrNothing("zip")) {
             toastError("For ZIP, please fill out all fields or leave all fields blank.");
             setAssetError("For ZIP, please fill out all fields or leave all fields blank.");
             setTimeout(() => { setAssetError(null); }, 5000);
             return;
         }
    
         // If all validations pass, proceed with saving
         handelSaveDetails();
         await handleSave("fbx");
         if (version["gltf"].trim().length > 0){ await handleSave("gltf")}; // Only save gltf if fields are filled
         if (version["glb"].trim().length > 0){ await handleSave("glb")}; // Only save glb if fields are filled
         if (version["zip"].trim().length > 0){ await handleSave("zip")}; // Only save zip if fields are filled        
         getVersionHistory();
        }
    };

    useEffect(()=>{
        saveAssetsAsync();
    },[saveAssets]);

    const getVersionHistory =async()=>{
            try {
            let data = await apiClient.get(`${configData.config.UNO_URL}${GET_VERSION_HISTORY}/${uuid}`);
            if(data.list.hasOwnProperty("3D.ASSET.UNIVERSAL")){

              let list = data.list["3D.ASSET.UNIVERSAL"];
              const newVersionsList = {
                gltf: [],
                fbx: [],
                glb: [],
                zip: []
              };

            list.forEach((item) => {
                newVersionsList[item.data.type].push(item);
            });

            setVersionsList(newVersionsList);

            }

            } catch (error) {
            console.log(error);
            }
    };

    useEffect(()=>{
            getVersionHistory();
    },[])


    const handleSetVersion = (text, type) =>{
        setAssetVersion(pre=> ({...pre, [type]: text}))
    }

    const handleSelectRendererUsedTag = (file, type) =>{
        if(!file.value){
          setRendererUsedTag(pre=> ({...pre, [type]: null}))
          return;
        }
        setRendererUsedTag(pre=> ({...pre, [type]: file}))
    }

    const handleChangeUploadFile = async (file, type) => {
        try {
           
           setUploadFile(pre => ({ ...pre, [type]: null }));
           setUploadProgress(pre => ({...pre, [type]: 0}));
           setError(pre => ({...pre, [type]: null  }));
           
           const uploadedFile = file;
           const formData = new FormData();
           formData.append('file', uploadedFile);
           setUploadFile(pre => ({ ...pre, [type]: file }));
    
          let { data } = await axios.post(`${configData.config.UNO_URL}/api/resource/3d/asset/upload/universal/${uuid}`, formData, {
            headers: {
              Authorization: `Bearer ${userData?.token}`,
              "Content-Type": "multipart/form-data"
            },
            onUploadProgress: (progressEvent) => {
                let progress = (progressEvent.loaded / progressEvent.total) * 100;
                if (progress < 100) {
                    setUploadProgress(pre => ({...pre, [type]: Math.floor(progress)}));
                }
            }
        });
        
        setUploadProgress(pre => ({...pre, [type]: 100}));
        setUploadedFile(pre => ({...pre, [type]: {url: data.url}}))
    
        } catch (error) {
          console.log(error)
        }
      };

    const handleRemoveFile = (fileType) => {
        setUploadFile(pre => ({ ...pre, [fileType]: null }));
        setUploadProgress(pre => ({...pre,  [fileType]: 0}));
    };

    const handleSave = async(type) =>{
        try {
            if(loading[type]) return;
            setError(pre => ({ ...pre, [type]: null }));
            setLoading(pre => ({...pre, [type]: true }));
            
            if(!uploadFile[type]){ setError(pre => ({...pre, [type]: "Kindly upload file."  })); return; } 
            if(!renderer[type]){ setError(pre => ({...pre, [type]: "Kindly select renderer."  })); return; }
            if(version[type].trim().length === 0){ setError(pre => ({...pre, [type]: "Kindly enter version."  })); return; }

            let _bodyData={      
                platform: "universal",
                type: type,
                assets: [{type: type.toUpperCase(), url: uploadedFile[type].url}],
                renderer: renderer[type].value,
                version: version[type]
            }
            await apiClient.post(`${configData.config.UNO_URL}${ASSET_CREATE_VERSION}/universal/${uuid}`, _bodyData);
    
        } catch (error) {
            console.log(error);
        } finally{
            setLoading(pre=> ({...pre, [type]: false}));
            setUploadFile(pre=> ({ ...pre, [type]: null}));
            setRendererUsedTag(pre=> ({ ...pre, [type]: null}));
            setAssetVersion(pre=> ({ ...pre, [type]: ""}));
            setUploadProgress(pre=> ({...pre,  [type]: 0}));
            return
        }


    }


  return (
    <>
    <div className='assets-upload'>
      <div className='row'>
            {[ {label:"GLTF", key:"gltf", viewFilePreview:true, showAsterisk:false},
               {label:"FBX", key:"fbx", viewFilePreview:false, showAsterisk:true},
               {label:"GLB", key:"glb", viewFilePreview:true, showAsterisk:false},
               {label:"ZIP (Additional texture)", key:"zip", viewFilePreview:false, showAsterisk:false},
                ].map((item,index)=>{
                    return(
                        <UploadSection
                            key={index+1}
                            FileUploader={FileUploader}
                            handleChangeUploadFile={handleChangeUploadFile}
                            assetFileType={item.key}
                            viewFilePreview={item.viewFilePreview}
                            showAsterisk={item.showAsterisk}
                            label={item.label}
                            renderer={renderer[item.key]}
                            version={version[item.key]}
                            setVersion={handleSetVersion}
                            error={error[item.key]}
                            Progress={Progress}
                            rendererTagList={rendererTagList}
                            Select={Select}
                            handleSelectRendererUsedTag={handleSelectRendererUsedTag}
                            // handleSave={handleSave}
                            loading={loading[item.key]}
                            uploadFile={uploadFile[item.key]}
                            uploadProgress={uploadProgress[item.key]}
                            versionsList={versionsList[item.key]}
                            removeFile={handleRemoveFile}
                        />
                    )
                })}

      </div>
      </div>
    </>
    
  )
}

export default UploadAsset;
